/*========================================================================
 * $Id: tabs.js 83469 2015-03-16 13:47:40Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/


define([
    "i18n/i18n",
    "utils/localStorage",
    "backbone",
    "underscore"
  ], function (
    i18n,
    localStorage,
    Backbone,
    _
  ) {
    

    /*
      id 
      name  - 
      state - initial,inprogress,finished
      interruptible
      progress
      
     */
    var State = {"INITIAL":0, "RUNNING": 1, "TERMINATED":2 }

    var TaskModel = Backbone.Model.extend({

      sync: function () {},
      
      initialize: function(attributes, options) {
        if (!this.attributes.state) {
          this.attributes.state = State.INITIAL;
        }

        Backbone.Model.prototype.initialize.apply(this, arguments);
        
        this.options = options || {}; 
      },
      
      progressAvailable: function() {
        return this.options.progressAvailable == true;
      },
      
      
      interruptible: function() {
        return this.options.interruptible == true;
      },


      state: function() {
        return this.get("state");
      },

      isFinished: function() {
        return this.get("finished") == true;
      },

      isCancelled: function() {
        return this.get("cancelled") == true;
      },

      isTerminated: function() {
        return this.state() == State.TERMINATED;
      },

      isRunning: function() {
        return this.state() == State.RUNNING;
      },


      start: function(atts, options) {

        atts = atts || {};
        atts = _.extend({}, atts, { state: State.RUNNING });

        this.set(atts, options);
        return this;
      },

      cancel: function(atts, options) {

        atts = atts || {};
        atts = _.extend({}, atts, { state: State.TERMINATED,
                                    cancelled: true });

        this.set(atts, options);
        return this;
      },

      finish: function(atts, options) {
        
        atts = atts || {};
        atts = _.extend({}, atts, { state: State.TERMINATED,
                                    finished: true });

        this.set(atts, options);
        return this;
      },

      stop: function(atts, options) {
        
        atts = atts || {};
        atts = _.extend({}, atts, { state: State.TERMINATED,
                                    finished: true,
                                    exportStatus: i18n("EXPORT_" + options.status) });

        this.set(atts, options);
        return this;
      },

      update: function(atts, options) {
        
        atts = atts || {};
        atts = _.extend({}, atts, { progress: options.progress,
                                    progressAvailable: options.progressAvailable });

        this.set(atts, options);
        return this;
      },

      get: function (key) {
        if (key === "isFinished") {
          return this.isFinished();
        }
        return Backbone.Model.prototype.get.apply(this, arguments);
      }
      
           
    });

    var Tasks = Backbone.Collection.extend({
      model: TaskModel,

      initialize: function() {
      }

    });

    return Tasks;
});
